function getSeriesGroup(node, rootNode) {
  let current = node.parentElement
  const vizRoot = rootNode.querySelector('#viz')

  while (current && current !== rootNode) {
    if (vizRoot && current.parentElement === vizRoot) {
      return current
    }
    current = current.parentElement
  }

  return rootNode
}

function applyTranslateY(node, deltaY) {
  const baseTransform =
    node.dataset.rawgraphsLabelBaseTransform ?? node.getAttribute('transform') ?? ''
  if (!node.dataset.rawgraphsLabelBaseTransform) {
    node.dataset.rawgraphsLabelBaseTransform = baseTransform
  }

  const trimmedBase = baseTransform.trim()
  const translate = `translate(0 ${Math.round(deltaY * 10) / 10})`
  node.setAttribute(
    'transform',
    trimmedBase ? `${trimmedBase} ${translate}` : translate
  )
}

function boxesOverlap(a, b, gap = 0) {
  return !(
    a.x + a.width + gap <= b.x ||
    b.x + b.width + gap <= a.x ||
    a.y + a.height + gap <= b.y ||
    b.y + b.height + gap <= a.y
  )
}

export function reduceBumpChartLabelOverlap(svgNode, gap = 4) {
  if (!svgNode?.querySelectorAll) return

  const labelNodes = Array.from(svgNode.querySelectorAll('#labels text'))
  if (!labelNodes.length) return

  const groups = new Map()
  labelNodes.forEach((node) => {
    const group = getSeriesGroup(node, svgNode)
    if (!groups.has(group)) {
      groups.set(group, [])
    }
    groups.get(group).push(node)
  })

  groups.forEach((nodes) => {
    const pointLabels = nodes.filter((node) => !node.querySelector('textPath'))
    const pathLabels = nodes.filter((node) => node.querySelector('textPath'))

    const measured = pointLabels
      .map((node) => {
        try {
          const bbox = node.getBBox()
          return Number.isFinite(bbox?.height) ? { node, bbox } : null
        } catch (error) {
          return null
        }
      })
      .filter(Boolean)
      .sort((a, b) => a.bbox.y - b.bbox.y)

    let previousBottom = -Infinity
    measured.forEach(({ node, bbox }) => {
      const overlap = previousBottom + gap - bbox.y
      const deltaY = overlap > 0 ? overlap : 0
      applyTranslateY(node, deltaY)
      previousBottom = bbox.y + deltaY + bbox.height
    })

    const pathMeasured = pathLabels
      .map((node) => {
        try {
          const bbox = node.getBBox()
          return Number.isFinite(bbox?.width) ? { node, bbox } : null
        } catch (error) {
          return null
        }
      })
      .filter(Boolean)
      .sort((a, b) => (a.bbox.y - b.bbox.y) || (a.bbox.x - b.bbox.x))

    const kept = []
    pathMeasured.forEach(({ node, bbox }) => {
      node.style.opacity = ''
      node.removeAttribute('data-bump-label-hidden')

      const collides = kept.some((keptBox) => boxesOverlap(bbox, keptBox, gap))
      if (collides) {
        node.style.opacity = '0'
        node.setAttribute('data-bump-label-hidden', 'true')
        return
      }

      kept.push(bbox)
    })
  })
}
